'use client';
import { CatIconWrench } from "blocks-nextjs/blocks-react/components/Icons/Wrench";
import cx from 'classnames';
import styles from '../product-description.module.scss';

const IconWrenchWrapper = () => {
    return (
        <CatIconWrench
            className={cx('u-fill--DarkGray', styles['cat-reman-icon'])}
        />
    )
}

export default IconWrenchWrapper;